export function compareNumericString(a: string, b: string): number {
    const aConverted = BigInt(a)
    const bConverted = BigInt(b)
    return (aConverted < bConverted) ? -1 : ((aConverted > bConverted) ? 1 : 0)
}

export function compareOptionalDate(a?: Date, b?: Date): number {
    const dateValueA = a ? a.valueOf() : 0
    const dateValueB = b ? b.valueOf() : 0
    return dateValueB - dateValueA
}
